import "./TheForge.module.css";
import Header from "@/reusable_sections/Header";
import StrategicPartnership from "./sections/StrategicPartnership";
import OurChauffeurTourPackages from "./sections/OurChauffeurTourPackages";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function TheForgePage() {
  return <div>
      <Header />
      <StrategicPartnership />
      <OurChauffeurTourPackages />
      <CommonQuestions />
      <Footer />
    </div>;
}